import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useDeepLinkRedirect } from "hooks/useDeepLinkRedirect";
import { getUpdateCardRoute } from "utils/updateCardRoute";

const UpdateCardRedirect = () => {
  const { id } = useParams<{ id: string }>();
  const route = useMemo(() => getUpdateCardRoute(id), [id]);

  useDeepLinkRedirect(route);

  return (
    <div className="h-[var(--shell-vh)] w-full grid place-items-center">
      <div
        className="inline-block h-10 w-10 animate-spin rounded-full border-2 border-solid border-blue border-r-transparent"
        role="status"
        aria-label="Opening payment methods"
      />
    </div>
  );
};

export default UpdateCardRedirect;
